<script>
import { mapGetters } from "vuex";
import { sanitizeUtmValue } from "@/utils/utmStorage";

export default {
  computed: {
    ...mapGetters("invitation_vacancy", [
      "logo",
      "jobTitle",
      "isLoading",
      "talentId",
      "inviteStatus",
      "isLoadingInvite",
      "jobDescription",
      "workload",
      "skills",
      "benefits",
      "location",
      "regime",
      "salaryRange",
      "showRegime",
      "showLocation",
      "showRemuneration",
      "message",
    ]),
    token() {
      const { token = "" } = this.$router.history.current.params;
      return token;
    },
    utm_source() {
      return (
        sanitizeUtmValue(this.$router.history.current.query.utm_source) ||
        "base-recrutei"
      );
    },
    utm_medium() {
      return (
        sanitizeUtmValue(this.$router.history.current.query.utm_medium) ||
        "email"
      );
    },
    utm_campaign() {
      return sanitizeUtmValue(this.$router.history.current.query.utm_campaign);
    },
    InvitedMessage() {
      return this.inviteStatus === "accepted"
        ? "Você já aceitou o convite para o processo seletivo desta vaga."
        : "Você já recusou o convite para o processo seletivo desta vaga.";
    },
  },
  methods: {
    onInviteAccepted() {
      this.$store.dispatch("invitation_vacancy/onInviteAcceptedRequest", {
        token: this.token,
        talent_id: this.talentId,
        utm_source: this.utm_source,
        utm_medium: this.utm_medium,
        utm_campaign: this.utm_campaign,
      });
    },
    onInviteRefused() {
      this.$store.dispatch("invitation_vacancy/onInviteRefusedRequest", {
        token: this.token,
        talent_id: this.talentId,
        utm_source: this.utm_source,
        utm_medium: this.utm_medium,
        utm_campaign: this.utm_campaign,
      });
    },
  },
  created() {
    this.$store.dispatch("invitation_vacancy/fetchInvitationVacancyRequested", {
      token: this.token,
      utm_source: this.utm_source,
      utm_medium: this.utm_medium,
      utm_campaign: this.utm_campaign,
    });
  },
  watch: {
    isLoading(value) {
      if (value) this.$vs.loading({});
      else this.$vs.loading.close();
    },
    isLoadingInvite(value) {
      if (value) this.$vs.loading({});
      else this.$vs.loading.close();
    },
  },
};
</script>

<template>
  <div class="error-message" v-if="message">
    <h1>{{ message }}</h1>
    <vs-button
      class="mx-1 my-4"
      @click="$router.push({ name: 'dashboard-vacancy' })"
      color="primary"
      type="filled"
    >
      Acessar Área do Candidato
    </vs-button>
  </div>
  <div class="invite-job invite-job__container" v-else>
    <div v-if="!isLoading" class="invite-job__header">
      <img :src="logo" alt="logo da empresa" />
    </div>
    <div v-if="!isLoading" class="invite-job__card">
      <div class="invite-job__card-content">
        <h1>{{ jobTitle }}</h1>

        <div class="invite-job__card-group">
          <feather-icon
            icon="MapIcon"
            svgClasses="h-4 w-4 text-primary"
            class="m-1"
          />
          <span>{{ location }}</span>
        </div>

        <div class="invite-job__card-group" v-if="jobDescription.length">
          <h2>Descrição da vaga</h2>
          <p v-html="jobDescription"></p>
        </div>

        <div v-if="workload.length" class="invite-job__card-group">
          <h2>Carga horária semanal</h2>
          <div class="flex items-center">
            <feather-icon
              icon="CheckCircleIcon"
              svgClasses="h-4 w-4 text-primary"
              class="m-1"
            />
            {{ workload }} {{ Number(workload) > 1 ? "horas" : "hora" }}
          </div>
        </div>

        <div class="invite-job__card-group" v-if="showRegime">
          <h2>Regime de Contratação</h2>
          <div class="flex items-center">
            <feather-icon
              icon="CheckCircleIcon"
              svgClasses="h-4 w-4 text-primary"
              class="m-1"
            />
            {{ regime }}
          </div>
        </div>

        <div class="invite-job__card-group" v-if="showRemuneration">
          <h2>Faixa Salarial</h2>
          <div class="flex items-center">
            <feather-icon
              icon="CheckCircleIcon"
              svgClasses="h-4 w-4 text-primary"
              class="m-1"
            />
            <span>{{ salaryRange }}</span>
          </div>
        </div>

        <div class="invite-job__card-group" v-if="skills.length">
          <h2>Conhecimentos e Habilidades necessárias</h2>
          <ul v-for="(skill, index) in skills" :key="`skill-${index}`">
            <div class="flex items-center">
              <feather-icon
                icon="CheckCircleIcon"
                svgClasses="h-4 w-4 text-primary"
                class="m-1"
              />
              <li>{{ skill }}</li>
            </div>
          </ul>
        </div>

        <div class="invite-job__card-group" v-if="benefits.length">
          <h2>Benefícios</h2>
          <ul v-for="(benefit, index) in benefits" :key="`benefit-${index}`">
            <div class="flex items-center">
              <feather-icon
                icon="CheckCircleIcon"
                svgClasses="h-4 w-4 text-primary"
                class="m-1"
              />
              <li>{{ benefit }}</li>
            </div>
          </ul>
        </div>

        <div class="invite-job__card-actions" v-if="inviteStatus === 'pending'">
          <vs-button
            class="mx-1 my-4"
            @click="onInviteAccepted"
            color="primary"
            type="filled"
          >
            Aceitar convite
          </vs-button>
          <vs-button
            class="mx-1 my-4"
            @click="onInviteRefused"
            color="danger"
            type="border"
          >
            Recusar
          </vs-button>
        </div>
        <div class="invite-job__card-actions" v-else>
          <p>{{ InvitedMessage }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.error-message {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  max-width: 80%;
  margin: 0 auto;
  flex-direction: column;
  gap: 24px;

  h1 {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    color: #475467;
    text-align: center;
  }
}
.invite-job {
  background: #f2f4f7;

  &__container {
    min-height: 100vh;
  }

  &__header {
    width: 100%;
    height: 60px;
    padding: 10px 60px;

    background: #fff;

    img {
      max-height: 42px;
    }
  }

  &__card {
    width: 80%;
    margin: 0 auto;
    margin-top: 40px;
    border-radius: 6px;
    background: #fff;

    &-content {
      padding: 50px;

      h1 {
        font-family: "Source Sans Pro";
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 30px;
        color: #475467;
      }

      h2 {
        margin-bottom: 16px;
        font-family: "Source Sans Pro";
        font-style: normal;
        font-weight: 600;
        font-size: 22px;
        line-height: 30px;
        color: #475467;
      }
    }

    &-group {
      margin: 16px 0;
    }

    &-actions {
      display: flex;

      @media screen and (max-width: 576px) {
        flex-direction: column;
      }
    }
  }
}
</style>
